import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { IProductInput } from "@/interfaces/product.interface";
import productService from "@/services/product.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateProductProps = UpdateByIdProps<IProductInput>;

export type UseUpdateProductReturn = {
  update: (props: UpdateProductProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateProduct = (): UseUpdateProductReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdate<IProductInput>({
    operation: (formData, productId) => productService.update(formData, productId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update,
  };
};
export default useUpdateProduct;
